import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["hourlyTitle", "hourlyBoard", "callsTitle", "callsBoard", "5555", "bodyTable", "7777", "8888", "9999"]

  connect() {
    this.numberController = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.controllerName = `app--communications--voips--calls--resume`
    this.sort = { mode: `asc`, field: `hour` }
  }

  doResumeCard() {
    this.calculation = {}
    this.calculation.totalCalls = 0
    this.calculation.normalClearing = 0
    this.calculation.originatorCancel = 0
    this.calculation.numberChanged = 0
    this.calculation.recoveryOnTimerExpire = 0
    this.calculation.exchangeRoutingError = 0
    this.calculation.unallocatedNumber = 0

    this.current_calls.forEach(element => {
      if (element.date_id == this.application.current_date.id) {
        this.calculation.totalCalls += 1
        if (element.hangup_cause == `NORMAL_CLEARING`) {
          this.calculation.normalClearing += 1
        } else if (element.hangup_cause == `ORIGINATOR_CANCEL`) {
          this.calculation.originatorCancel += 1
        } else if (element.hangup_cause == `NUMBER_CHANGED`) {
          this.calculation.numberChanged += 1
        } else if (element.hangup_cause == `RECOVERY_ON_TIMER_EXPIRE`) {
          this.calculation.recoveryOnTimerExpire += 1
        } else if (element.hangup_cause == `EXCHANGE_ROUTING_ERROR`) {
          this.calculation.exchangeRoutingError += 1
        } else if (element.hangup_cause == `UNALLOCATED_NUMBER`) {
          this.calculation.unallocatedNumber += 1
        }
      }
    })

    // `<div class="col-12 my-2 px-2 text-center">
    //   <span class="f-075 f-bold">Motivos Desligamentos</span>
    // </div>`

    var html = `<div class="row">
                  <div class="col-3 px-0">
                    <div class="row">
                      <div class="col-6 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Total de Ligações</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.totalCalls)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.totalCalls * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Atendidas</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.normalClearing)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.normalClearing * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-9 px-0">
                    <div class="row">
                      <div class="col-1 my-2 px-2"></div>
                      <div class="col-2 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Cancelamento</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.originatorCancel)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.originatorCancel * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Caixa Postal</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.numberChanged)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.numberChanged * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Tempo Expirado</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.recoveryOnTimerExpire)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.recoveryOnTimerExpire * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Erro de Conexão</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.exchangeRoutingError)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.exchangeRoutingError * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 my-2 px-2">
                        <div class="card">
                          <div class="card-header p-1 text-center f-070">
                            <span>Não Encontrado</span>
                          </div>
                          <div class="card-body text-center f-070 px-1 py-2">
                            <div class="row d-flex align-items-center mb-1">
                              <div class="col-12 text-center f-075 px-1">
                                <strong>${this.numberController.numberMask(this.calculation.unallocatedNumber)}</strong>
                                <small>${this.numberController.percentOptionMask((this.calculation.unallocatedNumber * 100 / this.calculation.totalCalls))}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`

    this.getControllerByIdentifier(`app--communications--voips--calls--dashboard`).resumeTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  getTargetByIdentifier(target) {
    var targetElement = ``
    this.application.controllers.forEach(controller => {
      if (controller.targets.find(target)) {
        targetElement = controller.targets.find(target)
      }
    })

    return targetElement
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  confirm() {
    var r = confirm("Confirma a resolução do Ticket?")
    if (r) {
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    return results
  }

  randonNumber() {
    var number = Math.floor(Math.random() * 1000)

    return number
  }

  requireUser() {
    var user = this.getControllerByIdentifier("app--visits--users").checkUser()

    if (user) {
      this.doMainGrid()
    } else {
      window.open(window.location.origin, `_self`)
    }
  }

  leadingZeros(number, size) {
    var s = String(number);
    while (s.length < (size || 2)) { s = "0" + s; }
    return s;
  }

  // controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(9, 6))
  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
